import React from 'react';
import { Paper, Box, Typography, Divider } from '@material-ui/core';
import CampaignList from '../components/campaign/CampaignList';
import { useTranslation } from 'react-i18next';


const CampaignListView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Paper elevation={2}>
        <Box p={4} mb={4}>
          <Typography variant="h4">{t('campaigns')}</Typography>
          <Divider />
          <CampaignList />
        </Box>
      </Paper>
    </>
  );
};


export default CampaignListView;
